export const selectIsPointCloudGeoSearchOpen = (state) => Boolean(state.pointCloudGeoSearch.isOpen)
